import { CheckCircle, Package, MapPin, AlertCircle } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

export function LastScannedCard({ lastScanned }) {
  if (!lastScanned) return null;

  const isCreated = lastScanned.action === "created";

  return (
    <Card
      className={`border-2 ${isCreated ? "border-green-500" : "border-primary"}`}
      data-testid="last-scanned"
    >
      <CardContent className="p-4">
        <div className="flex items-start gap-3">
          <div className={`p-2 rounded-full ${isCreated ? "bg-green-500/10" : "bg-primary/10"}`}>
            <CheckCircle className={`h-5 w-5 ${isCreated ? "text-green-500" : "text-primary"}`} />
          </div>
          <div className="flex-1">
            <p className="font-medium text-lg">
              {lastScanned.item?.artikelnummer || lastScanned.item?.ean}
            </p>
            {lastScanned.item?.produktnamn && (
              <p className="text-muted-foreground text-sm">{lastScanned.item.produktnamn}</p>
            )}
            <div className="flex items-center gap-2 mt-2">
              <Badge variant={isCreated ? "default" : "secondary"}>
                {isCreated ? "Ny produkt" : "Uppdaterad"}
              </Badge>
              <Badge variant="outline" className="gap-1">
                <MapPin className="h-3 w-3" />
                {lastScanned.item?.lagerplats}
              </Badge>
              <Badge variant="outline">
                <Package className="h-3 w-3 mr-1" />
                {lastScanned.item?.antal} st
              </Badge>
            </div>
          </div>
        </div>
        {lastScanned.message && (
          <p className="text-sm text-muted-foreground mt-2 flex items-center gap-1">
            <AlertCircle className="h-4 w-4" />
            {lastScanned.message}
          </p>
        )}
      </CardContent>
    </Card>
  );
}
